import axios from "../axios-instance";
import {ZERO} from './constants';
import {ModalDialog} from './modal-dialog/index';
import {createFormData} from 'modules/helpers/form-data-helper';

const activeFieldCheck = id => {
  const field = document.getElementById(id);
  field.oncut = field.oncopy = field.oninput = () => {
    field.value = field.value.replace(/[^0-9,a-z]/g, '');
  }
}

const submitAddEvent = (scheduleName, id, modalObject) => {
  const sids = document.getElementById('sids-for-add').value.split(',');
  const data = {
    'app_sids': sids,
    'update_schedule_id': id
  }
  axios.post('/update_schedule/save_appliances', createFormData(data))
  .then(response => {
    if (response.data.warnings.length !== ZERO) {
      let warningsMessage = `
        <span style="font-weight:bold;">${ADD_APPLIANCES_SIDS_WARNING_TITLE} ${scheduleName}</span>
      `;
      for (let message of response.data.warnings) {
        warningsMessage = warningsMessage + `<p>${message}</p>`;
      }
      modalObject.destroyModalBox();
      show_alert(ERROR_LABEL_CHECKOUT, warningsMessage);
    } else {
      modalObject.destroyModalBox();
    }
  })
  .catch();
};

const openAddWindow = (scheduleName, id) => {
  const options = {
    method: `/update_schedule/add_sids_to_update_schedule_dialog/${id}`
  };
  const modal = new ModalDialog(options);
  modal.getTemplate()
    .then(resp => {
      if (resp) {
        activeFieldCheck('sids-for-add');
        document
          .querySelector('.js-submit-add-sids-btn')
          .addEventListener('click', () => submitAddEvent(scheduleName, id, modal));
      }
    })
    .catch();
};

export default {openAddWindow};
